import React from 'react'
import IMG1 from  '../IMG/01.jpg'
import IMG2 from  '../IMG/02.jpg'
import IMG3 from  '../IMG/03.jpg'
export default function Carusell() {
  return (
    <>

  <div
        id="carouselExampleInterval"
        className="carousel slide "
        data-bs-ride="carousel"
      >
        <div className="carousel-inner ">
          <div className="carousel-item active" data-bs-interval="10000">
            <img
              src={IMG1}
              className="d-block w-100"
              alt="IMAGEN-AUTO-GAS-YONI-LOCAL"
            />
          </div>
          <div className="carousel-item" data-bs-interval="2000">
            <img
              src={IMG2}
              className="d-block w-100"
              alt="IMAGEN-AUTO-GAS-YONI-LOCAL"
            />
          </div>
          <div className="carousel-item">
            <img
              src={IMG3}
              className="d-block w-100"
              alt="IMAGEN-AUTO-GAS-YONI-LOCAL"
            />
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="prev"
        >
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="next"
        >
          <span className="visually-hidden">Next</span>
        </button>


</div>



    </>
  )
}
